function do_debounce(func, timeout){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

const debounce = (callback, timeout = 300) => do_debounce(() => callback(), timeout);

export default debounce;